import clsx from 'clsx'

export function TelegramIcon({ className = '' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="21"
      viewBox="0 0 25 21"
      className={clsx('text-[#5B5B5B]', className)}
      aria-hidden="true"
    >
      <path
        d="M9.77977 14.076L9.38393 19.6436C9.95027 19.6436 10.1956 19.4003 10.4897 19.1082L13.1449 16.5706L18.6468 20.5998C19.6558 21.1622 20.3667 20.866 20.6389 19.6715L24.2503 2.74918L24.2513 2.74819C24.5714 1.25656 23.7119 0.673273 22.7288 1.0392L1.50106 9.16636C0.0523056 9.72871 0.0742412 10.5363 1.25478 10.9023L6.68186 12.5903L19.2879 4.70245C19.8811 4.30961 20.4206 4.52697 19.9769 4.91982L9.77977 14.076Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  )
}
